// JOBE-0098.5: canonical chord list shared between the Shell's help
// sheet and the OmniPalette footer. One source of truth so the help
// surface and the in-palette legend can't drift. Frozen so a consumer
// can't accidentally mutate the shared array.
//
// `context` groups rows in the help sheet: 'shell' = chords registered
// at the SPA-shell level (this subtask); 'palette' = within-palette
// chords owned by JOBE-0098.3; 'promptops-agent' = JOBE-0165 W5 page-local
// chords (filtered into the help sheet only when the user is on the
// `/promptops/agent/:name` route).
export const OMNI_CHORDS = Object.freeze([
  { chord: '⌘,',  context: 'shell',   label: 'Open the search palette' },
  { chord: '⌘F',  context: 'shell',   label: 'Open the search palette (captures browser Find)' },
  { chord: '/',   context: 'shell',   label: 'Focus the search palette (Vim-style)' },
  { chord: '?',   context: 'shell',   label: 'Show this help' },
  { chord: '⌘K',  context: 'shell',   label: 'Open the app-wide picker (unchanged)' },
  { chord: '⌘.',  context: 'shell',   label: 'Open the app-wide picker (alternate binding)' },
  { chord: 'g l', context: 'shell',   label: 'Navigate to Library' },
  // JOBE-0168: g e opens the Entity Browser at /entities.
  { chord: 'g e', context: 'shell',   label: 'Navigate to Entity Browser' },
  { chord: 'g c', context: 'shell',   label: 'Navigate to Contacts' },
  { chord: '↑ ↓', context: 'palette', label: 'Move highlight (in the search palette)' },
  { chord: '⇥',   context: 'palette', label: 'Accept autocomplete (in the search palette)' },
  { chord: '↩',   context: 'palette', label: 'Run as typed (in the search palette)' },
  { chord: '⇧↩',  context: 'palette', label: 'Apply as filters & close (in the search palette)' },
  { chord: '⌘↩',  context: 'palette', label: 'Save view… (in the search palette)' },
  { chord: 'Esc', context: 'palette', label: 'Close palette' },
  // JOBE-0165.5: W5 PromptOps Agent page-local chords. Filtered into the help
  // sheet only on `/promptops/agent/:name` routes (see OmniChordHelpSheet).
  { chord: 'E',   context: 'promptops-agent', label: 'Focus candidate prompt actions (W5)' },
  { chord: 'B',   context: 'promptops-agent', label: 'Focus fix bundle (W5)' },
  { chord: '↑ ↓', context: 'promptops-agent', label: 'Navigate failure cluster cards (W5)' },
].map((e) => Object.freeze(e)));
